// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
export const environment = {
  production: false,
  frontendBaseUrl: "https://investorportal.dev.ace-alternatives.com",
  //baseUrl: "https://investor-portal-mock-dev.ace-alternatives.com",
  baseUrl: "https://pcportaldev.api.suite7.io/v1",

  realApiBaseUrl: "https://api.investorportal.dev.ace-alternatives.com",
  useRealAPI: false,
  authUrl: "https://auth.ace-alternatives.com/auth/realms/ace-test",
  tokenEndpoint:
    "https://auth.ace-alternatives.com/auth/realms/ace-test/protocol/openid-connect/token",
  clientId: "investor-portal.app",
  pdfjsExpressViewerLicenseKey: "o3bkD7xCH0gXitwvFfM8",
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
